<template>
  <v-autocomplete
    v-model="selectedColaboradores"
    :label="!loading ? label : `${label} (Carregando)`"
    item-text="nome"
    item-value="cpf"
    :items="arrayColaboradores"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    :loading="loading"
    @change="onChanged()"
  >
    <template v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedColaboradores.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
import rules from "@/utils/rules";
import Colaborador from "@/services/colaborador";
import Equipe from "@/services/equipe";

export default {
  name: "SelectColaborador",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    empresas: {
      type: Array | String,
      required: false
    },

    mounted: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: "Colaboradores"
    },

    selecionado: {
      type: [Array, String],
      default: () => { return new Array() }
    }
  },

  data() {
    return {
      loading: false,
      arrayColaboradores: new Array(),

      selectedColaboradores: this.selecionado,

      rules: rules
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"])
  },

  methods: {
    async getColaboradores() {
      this.arrayColaboradores = new Array()
      this.loading = true

      try {
        let colaboradores;
        let empresas = this.empresas;

        if (!empresas || empresas.length == 0) {
          this.arrayColaboradores = [];
          return;
        }

        if (!Array.isArray(empresas)) {
          empresas = [empresas];
        }

        if (this.getUser.papel.toUpperCase() == "VENDEDOR") {
          this.arrayColaboradores = [this.getUser.colaborador];
          return;
        }

        colaboradores = await new Colaborador().getByEmpresas(empresas);

        this.arrayColaboradores = colaboradores;
      } catch (error) {
        this.$toast.error(error);
      }finally{
        this.loading = false
      }
    },

    selectAll(all = true) {
      if (all) {
        this.selectedColaboradores = this.arrayColaboradores.map(
          value => value.cpf
        );
      } else {
        this.selectedColaboradores = [];
      }

      this.onChanged();
    },

    onChanged() {
      const filtered = this.arrayColaboradores.filter(value =>
        this.selectedColaboradores.includes(value.cpf)
      );
      this.$emit("onChanged", filtered);
    },

    removeSelected(colaborador) {
      let index = this.selectedColaboradores.indexOf(colaborador.cpf)
      this.selectedColaboradores.splice(index, 1)
      this.onChanged()
    }
  },

  watch: {
    empresas: {
      handler() {
        this.selectedColaboradores = [];
        this.getColaboradores();
      },
      deep: true
    },
    selecionado: {
      handler() {
        this.selectedColaboradores = this.selecionado;
      },
      deep: true
    }
  },

  mounted() {
    if (this.mounted) {
      this.getColaboradores();
    }
  }
};
</script>
